import { render, staticRenderFns } from "./AffiliatePayoutPage.vue?vue&type=template&id=f31b97c6&"
import script from "./AffiliatePayoutPage.vue?vue&type=script&lang=js&"
export * from "./AffiliatePayoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports